import crud from '../crud'
var p = new crud('flags', 'hashtag');

export default {
    actions: {...p.actions},
    mutations: {...p.mutations},
    namespaced: true,
    state: {...p.state},
};
